import * as Yup from 'yup';

const CloudPrintSchema = Yup.object().shape({
  StarPrintUser: Yup.string().required('Username field is required!'),
  StarPrintPassword: Yup.string().required('Password field is required!')
});

export default CloudPrintSchema;
